// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// Images Module

// Define the attributes for application images

define('Images',['require','MobileUtils','ReturnCodes'],function (require) {
    'use strict';

    var // Require.js module dependencies
        MobileUtils = require('MobileUtils'),
        ReturnCodes = require('ReturnCodes'),

        // Dependent resources
        mobileUtils = new MobileUtils(),
        returnCodes = new ReturnCodes(),

        // Site image ids and corresponding image files
        siteImages = {

            'about': {
                src: './img/about.png',
                alt: 'About Application'
            },

            'add-favorite': {
                src: './img/add_favorite.png',
                alt: 'Add Favorite'
            },

            'apple-touch-icon': {
                src: './img/apps/APPNAME/apple-touch-icon.png',
                alt: 'Application Logo'
            },

            'ambiance-category': {
                src: './img/ratingCategories/ambiance.png',
                alt: 'Ambiance Rating Category'
            },

            'avatar-default': {
                src: './img/avatars/avatar_default.png',
                alt: 'Default Avatar Image'
            },

            'avatar1': {
                src: './img/avatars/avatar1.png',
                alt: 'Avatar 1 Image'
            },

            'avatar10': {
                src: './img/avatars/avatar10.png',
                alt: 'Avatar 10 Image'
            },

            'avatar11': {
                src: './img/avatars/avatar11.png',
                alt: 'Avatar 11 Image'
            },

            'avatar12': {
                src: './img/avatars/avatar12.png',
                alt: 'Avatar 12 Image'
            },

            'avatar2': {
                src: './img/avatars/avatar2.png',
                alt: 'Avatar 2 Image'
            },

            'avatar3': {
                src: './img/avatars/avatar3.png',
                alt: 'Avatar 3 Image'
            },

            'avatar4': {
                src: './img/avatars/avatar4.png',
                alt: 'Avatar 4 Image'
            },

            'avatar5': {
                src: './img/avatars/avatar5.png',
                alt: 'Avatar 5 Image'
            },

            'avatar6': {
                src: './img/avatars/avatar6.png',
                alt: 'Avatar 6 Image'
            },

            'avatar7': {
                src: './img/avatars/avatar7.png',
                alt: 'Avatar 7 Image'
            },

            'avatar8': {
                src: './img/avatars/avatar8.png',
                alt: 'Avatar 8 Image'
            },

            'avatar9': {
                src: './img/avatars/avatar9.png',
                alt: 'Avatar 9 Image'
            },

            'badge0': {
                src: './img/badges/wayfarer.png',
                alt: 'Wayfarer Badge'
            },

            'badge1': {
                src: './img/badges/goatherder.png',
                alt: 'Goatherder Badge'
            },

            'badge2': {
                src: './img/badges/shepherd.png',
                alt: 'Shepherd Badge'
            },

            'badge3': {
                src: './img/badges/gaucho.png',
                alt: 'Gaucho Badge'
            },

            'badge4': {
                src: './img/badges/buckaroo.png',
                alt: 'Buckaroo Badge'
            },

            'badge5': {
                src: './img/badges/cowhand.png',
                alt: 'Cowhand Badge'
            },

            'badge6': {
                src: './img/badges/wrangler.png',
                alt: 'Wrangler Badge'
            },

            'badge7': {
                src: './img/badges/rancher.png',
                alt: 'Rancher Badge'
            },

            'badge8': {
                src: './img/badges/stockman.png',
                alt: 'Stockman Badge'
            },

            'badge9': {
                src: './img/badges/ranger.png',
                alt: 'Ranger Badge'
            },

            'bar-crowd-category': {
                src: './img/ratingCategories/barcrowd.png',
                alt: 'Bar Crowd Rating Category'
            },

            'birthyear': {
                src: './img/cake.png',
                alt: 'Birthday Cake'
            },

            'broken-image': {
                src: './img/broken_image.png',
                alt: 'Broken Image'
            },

            'camera': {
                src: './img/camera.png',
                alt: 'Camera'
            },

            'camera-button': {
                src: './img/camera_button.png',
                alt: 'Camera'
            },

            'checkbox-checked': {
                src: './img/checkbox_checked.png',
                alt: 'Checked Checkbox'
            },

            'checkbox-unchecked': {
                src: './img/checkbox_unchecked.png',
                alt: 'Unchecked Checkbox'
            },

            'clean-category': {
                src: './img/ratingCategories/clean.png',
                alt: 'Clean Rating Category'
            },

            'clusterimage': {
                src: './img/pinflags/density-marker.png',
                alt: 'Cluster Image'
            },

            'company-logo': {
                src: './img/tramplezone_logo.png',
                alt: 'Company Logo'
            },

            'crowd-category': {
                src: './img/ratingCategories/barcrowd.png',
                alt: 'Crowd Rating Category'
            },

            'delete-button': {
                src: './img/delete_button.png',
                alt: 'Delete Button'
            },

            'downarrow': {
                src: './img/downarrow.png',
                alt: 'Down'
            },

            'drag-me': {
                src: './img/pinflags/drag-me.png',
                alt: 'Drag Me Map Marker Image'
            },

            'edibles-category': {
                src: './img/ratingCategories/edibles.png',
                alt: 'Edibles'
            },

            'edit': {
                src: './img/edit_options.png',
                alt: 'Edit Options'
            },

            'email': {
                src: './img/email.png',
                alt: 'Email'
            },

            'error': {
                src: './img/error.png',
                alt: 'Error'
            },

            'entertainment-category': {
                src: './img/ratingCategories/entertainment.png',
                alt: 'Entertainment Rating Category'
            },

            'envelope': {
                src: './img/envelope.png',
                alt: 'Email Envelope'
            },

            'facebook': {
                src: './img/avatars/facebook.png',
                alt: 'Facebook'
            },

            'faq': {
                src: './img/faq.png',
                alt: 'Frequently Asked Questions'
            },

            'favorite': {
                src: './img/favorite.png',
                alt: 'Favorite Places'
            },

            'filter': {
                src: './img/filter.png',
                alt: 'Place Type Filter'
            },

            'dining-crowd-category': {
                src: './img/about.png',
                alt: 'Dining Crowd Rating Category'
            },

            'free': {
                src: './img/free.png',
                alt: 'Free'
            },

            'friends': {
                src: './img/friends.png',
                alt: 'Friends'
            },

            'geomarker': {
                src: './img/pinflags/gpsloc.png',
                alt: 'GPS Location'
            },

            'google-default-marker': {
                src: './img/pinflags/google-default-marker.png',
                alt: 'Google Default Marker'
            },

            'home': {
                src: './img/home.png',
                alt: 'Home Button'
            },

            'human-blue': {
                src: './img/humans/blue.png',
                alt: 'Blue Human'
            },

            'human-blue-yes': {
                src: './img/humans/blue_yes.png',
                alt: 'Blue Human Hands Up'
            },

            'human-lightblue': {
                src: './img/humans/lightblue.png',
                alt: 'Light Blue Human'
            },

            'human-lightblue-yes': {
                src: './img/humans/lightblue_yes.png',
                alt: 'Light Blue Human Hands Up'
            },

            'human-green': {
                src: './img/humans/green.png',
                alt: 'Green Human'
            },

            'human-green-yes': {
                src: './img/humans/green_yes.png',
                alt: 'Green Human Hands Up'
            },

            'human-lightgreen': {
                src: './img/humans/lightgreen.png',
                alt: 'Light Green Human'
            },

            'human-lightgreen-yes': {
                src: './img/humans/lightgreen_yes.png',
                alt: 'Light Green Human Hands Up'
            },

            'human-red': {
                src: './img/humans/red.png',
                alt: 'Red Human'
            },

            'human-red-yes': {
                src: './img/humans/red_yes.png',
                alt: 'Red Human Hands Up'
            },

            'human-lightred': {
                src: './img/humans/lightred.png',
                alt: 'Light Red Human'
            },

            'human-lightred-yes': {
                src: './img/humans/lightred_yes.png',
                alt: 'Light Red Human Hands Up'
            },

            'human-yellow': {
                src: './img/humans/yellow.png',
                alt: 'Yellow Human'
            },

            'human-yellow-yes': {
                src: './img/humans/yellow_yes.png',
                alt: 'Yellow Human Hands Up'
            },

            'human-orange': {
                src: './img/humans/orange.png',
                alt: 'Orange Human'
            },

            'human-orange-yes': {
                src: './img/humans/orange_yes.png',
                alt: 'Orange Human Hands Up'
            },

            'human-purple': {
                src: './img/humans/purple.png',
                alt: 'Purple Human'
            },

            'human-purple-yes': {
                src: './img/humans/purple_yes.png',
                alt: 'Purple Human Hands Up'
            },

            'human-gray': {
                src: './img/humans/gray.png',
                alt: 'Gray Human'
            },

            'human-gray-yes': {
                src: './img/humans/gray_yes.png',
                alt: 'Gray Human Hands Up'
            },

            'infowindow-call': {
                src: './img/infowindow_call.png',
                alt: 'Map Infowindow'
            },

            'infowindow-close': {
                src: './img/infowindow_close.png',
                alt: 'Infowindow Close Button'
            },

            'infowindow-nav': {
                src: './img/infowindow_nav.png',
                alt: 'Infowindow Navigation Button'
            },

            'infowindow-web': {
                src: './img/infowindow_web.png',
                alt: 'Infowindow Web Button'
            },

            'leaderboard': {
                src: './img/winner.png',
                alt: 'Winner'
            },

            'leftarrow': {
                src: './img/left_arrow.png',
                alt: 'Left Arrow'
            },

            'list-button': {
                src: './img/listbutton.png',
                alt: 'List Button'
            },

            'loading': {
                src: './img/loading.png',
                alt: 'Loading...'
            },

            'login': {
                src: './img/login.png',
                alt: 'Application Login'
            },

            'login-artwork': {
                src: './img/apps/APPNAME/login_artwork.png',
                alt: 'Application Logo'
            },

            'login-artwork2': {
                src: './img/apps/APPNAME/login_artwork2.png',
                alt: 'Application Logo'
            },

            'logo': {
                src: './img/apps/APPNAME/applogo_stacked.png',
                alt: 'Application Logo'
            },

            'map': {
                src: './img/map.png',
                alt: 'Map'
            },

            'map-button': {
                src: './img/mapbutton.png',
                alt: 'Map Button'
            },

            'mapfilter': {
                src: './img/mapfilter.png',
                alt: 'Place Type Filter'
            },

            'map-marker0': {
                src: './img/pinflags/pin-flag-norate.png',
                alt: 'Map Marker No Score'
            },

            'map-marker1': {
                src: './img/pinflags/pin-flag-1.png',
                alt: 'Man Marker Score 1'
            },

            'map-marker2': {
                src: './img/pinflags/pin-flag-2.png',
                alt: 'Map Marker Score 2'
            },

            'map-marker3': {
                src: './img/pinflags/pin-flag-3.png',
                alt: 'Map Marker Score 3'
            },

            'map-marker4': {
                src: './img/pinflags/pin-flag-4.png',
                alt: 'Map Marker Score 4'
            },

            'map-marker5': {
                src: './img/pinflags/pin-flag-5.png',
                alt: 'Map Marker Score 5'
            },

            'merchant': {
                src: './img/merchant.png',
                alt: 'Merchant'
            },

            'merchant-success': {
                src: './img/merchant_success.png',
                alt: 'Merchant Success'
            },

            'merchant-welcome': {
                src: './img/merchant_welcome.png',
                alt: 'Welcome Merchants'
            },

            'microphone-button': {
                src: './img/microphone_button.png',
                alt: 'Microphone'
            },

            'movie-button': {
                src: './img/movie_button.png',
                alt: 'Movie'
            },

            'merchant-offer': {
                src: './img/merchant_offer.png',
                alt: 'Merchant Offer'
            },

            'motd': {
                src: './img/motd.png',
                alt: 'Message Of The Day'
            },

            'no-specialoffer': {
                src: './img/no_specialoffer.png',
                alt: 'No Special Offer'
            },

            'oils-category': {
                src: './img/ratingCategories/oils.png',
                alt: 'Oils'
            },

            'password': {
                src: './img/password.png',
                alt: 'Password'
            },

            'password-match': {
                src: './img/password_match.png',
                alt: 'Password Match'
            },

            'password-mismatch': {
                src: './img/password_mismatch.png',
                alt: 'Password Mismatch'
            },

            'phone': {
                src: './img/phone.png',
                alt: 'Phone'
            },

            'photo-album': {
                src: './img/photo_album.png',
                alt: 'Photos'
            },

            'point': {
                src: './img/hand.png',
                alt: 'Hand'
            },

            'powered-by-google': {
                src: './img/powered_by_google.png',
                alt: 'Powered by Google'
            },

            'price-category': {
                src: './img/ratingCategories/price.png',
                alt: 'Price Rating Category'
            },

            'product-category': {
                src: './img/ratingCategories/product.png',
                alt: 'Product Rating Category'
            },

            'profile': {
                src: './img/profile.png',
                alt: 'User Profile'
            },

            'qr_code': {
                src: './img/qr_code.png',
                alt: 'QR Code'
            },

            'rating-category-default': {
                src: './img/ratingCategories/default.png',
                alt: 'Rating Category Icon'
            },

            'recorder-button': {
                src: './img/recorder_button.png',
                alt: 'Video Recorder'
            },

            'refer-friend': {
                src: './img/envelope.png',
                alt: 'Mail Envelope'
            },

            'remove-favorite': {
                src: './img/remove_favorite.png',
                alt: 'Remove Favorite'
            },

            'reset': {
                src: './img/reset.png',
                alt: 'Reset'
            },

            'rightarrow': {
                src: './img/right_arrow.png',
                alt: 'Right Arrow'
            },

            'sample-offer1': {
                src: './img/sample_offer1.png',
                alt: 'Merchant Offer 1'
            },

            'sample-offer2': {
                src: './img/sample_offer2.png',
                alt: 'Merchant Offer 2'
            },

            'sample-offer3': {
                src: './img/sample_offer3.png',
                alt: 'Merchant Offer 3'
            },

            'sample-offer4': {
                src: './img/sample_offer4.png',
                alt: 'Merchant Offer 4'
            },

            'score-none': {
                src: './img/score_none.png',
                alt: ''
            },

            'score1': {
                src: './img/score1.png',
                alt: 'Score 1'
            },

            'score2': {
                src: './img/score2.png',
                alt: 'Score 2'
            },

            'score3': {
                src: './img/score3.png',
                alt: 'Score 3'
            },

            'score4': {
                src: './img/score4.png',
                alt: 'Score 4'
            },

            'score5': {
                src: './img/score5.png',
                alt: 'Score 5'
            },

            'search': {
                src: './img/search.png',
                alt: 'Search'
            },

            'search-button': {
                src: './img/search_button.png',
                alt: 'Search Button'
            },

            'select': {
                src: './img/select.png',
                alt: 'Select Button'
            },

            'selection-category': {
                src: './img/ratingCategories/selection.png',
                alt: 'Selection'
            },

            'service-category': {
                src: './img/ratingCategories/service.png',
                alt: 'Service Rating Category'
            },

            'settings': {
                src: './img/settings.png',
                alt: 'Settings Button'
            },

            'smiley-face': {
                src: './img/smiley_face.png',
                alt: 'Smiley Face'
            },

            'socialmedia-blog': {
                src: './img/socialmedia/blog.png',
                alt: 'Blog Button'
            },

            'socialmedia-facebook': {
                src: './img/socialmedia/facebook.png',
                alt: 'Facebook Button'
            },

            'socialmedia-instagram': {
                src: './img/socialmedia/instagram.png',
                alt: 'Instagram Button'
            },

            'socialmedia-twitter': {
                src: './img/socialmedia/twitter.png',
                alt: 'Twitter Button'
            },

            'sound': {
                src: './img/sound.png',
                alt: 'Sound'
            },

            'specialoffer': {
                src: './img/specialoffer.png',
                alt: 'Special Offer'
            },

            'splashscreen': {
                src: './img/apps/APPNAME/splashscreen.png',
                alt: 'Splashscreen'
            },

            'stophand': {
                src: './img/stophand.png',
                alt: 'Stop Hand'
            },

            'strains-category': {
                src: './img/ratingCategories/strains.png',
                alt: 'Strains'
            },

            'submit': {
                src: './img/submit.png',
                alt: 'Submit'
            },

            'thumbs_down_gray': {
                src: './img/thumbs_down_gray.png',
                alt: 'Thumbs Down'
            },

            'thumbs_down_red': {
                src: './img/thumbs_down_red.png',
                alt: 'Thumbs Down Selected'
            },

            'thumbs_up_gray': {
                src: './img/thumbs_up_gray.png',
                alt: 'Thumbs Up'
            },

            'thumbs_up_green': {
                src: './img/thumbs_up_green.png',
                alt: 'Thumbs Up Selected'
            },

            'triangle': {
                src: './img/triangle.png',
                alt: 'Triangle'
            },

            'twitter': {
                src: './img/avatars/twitter_white.png',
                alt: 'Twitter'
            },

            'udl-marker0': {
                src: './img/pinflags/udl-flag-norate.png',
                alt: 'User Defined Place Map Marker No Score'
            },

            'udl-marker1': {
                src: './img/pinflags/udl-flag-1.png',
                alt: 'User Defined Place Map Marker Score 1'
            },

            'udl-marker2': {
                src: './img/pinflags/udl-flag-2.png',
                alt: 'User Defined Place Map Marker Score 2'
            },

            'udl-marker3': {
                src: './img/pinflags/udl-flag-3.png',
                alt: 'User Defined Place Map Marker Score 3'
            },

            'udl-marker4': {
                src: './img/pinflags/udl-flag-4.png',
                alt: 'User Defined Place Map Marker Score 4'
            },

            'udl-marker5': {
                src: './img/pinflags/udl-flag-5.png',
                alt: 'User Defined Place Map Marker Score 5'
            },

            'udl-place': {
                src: './img/udl_place.png',
                alt: 'User Defined Place'
            },

            'uparrow': {
                src: './img/uparrow.png',
                alt: 'Up'
            },

            'warning': {
                src: './img/warning.png',
                alt: 'Warning!'
            },

            'yelp': {
                src: './img/yelp/yelp.png',
                alt: 'Yelp'
            },

            'yelp_small_0': {
                src: './img/yelp/small_0.png',
                alt: 'Yelp'
            },

            'yelp_small_1': {
                src: './img/yelp/small_1.png',
                alt: 'Yelp'
            },

            'yelp_small_1.5' : {
                src: './img/yelp/small_1_half.png',
                alt: 'Yelp'
            },

            'yelp_small_2': {
                src: './img/yelp/small_2.png',
                alt: 'Yelp'
            },

            'yelp_small_2.5': {
                src: './img/yelp/small_2_half.png',
                alt: 'Yelp'
            },

            'yelp_small_3': {
                src: './img/yelp/small_3.png',
                alt: 'Yelp'
            },

            'yelp_small_3.5': {
                src: './img/yelp/small_3_half.png',
                alt: 'Yelp'
            },

            'yelp_small_4': {
                src: './img/yelp/small_4.png',
                alt: 'Yelp'
            },

            'yelp_small_4.5': {
                src: './img/yelp/small_4_half.png',
                alt: 'Yelp'
            },

            'yelp_small_5': {
                src: './img/yelp/small_5.png',
                alt: 'Yelp'
            }
        },

        // Instance vars
        self,
        appName,

        // Valid image protocols
        supportedProtocols = [
            'http',
            'https'
        ],

        // Valid Mimetypes and associated file extensions
        validMimetypes = {
            'image/png':    [ 'png', 'PNG' ],
            'image/jpeg':   [ 'jpg', 'JPG', 'jpeg', 'JPEG' ],
            'image/gif':    [ 'gif', 'GIF' ]
        },
        supportedMimetypes,
        supportedExtensions,

        // Maximum load time before timeout
        maxLoadTime = 10000,

        // Maximum size in megabytes
        maxSize = 20 * 1024 * 1024,

        // Possible load error return codes
        unableToCompleteRequestRC,
        unexpectedErrorRC,
        invalidParameterRC,
        contentMaxSizeExceededRC,
        successRC;


    // Constructor
    function Images () {
        // Preserve instance reference and enforce singleton
        if (typeof self === 'object') { return self; } else { self = this; }

        // Get load error codes
        unableToCompleteRequestRC =
            returnCodes.getCode('UNABLE_TO_COMPLETE_REQUEST_RC');
        unexpectedErrorRC =
            returnCodes.getCode('UNEXPECTED_ERROR_RC');
        invalidParameterRC =
            returnCodes.getCode('INVALID_PARAMETER_RC');
        contentMaxSizeExceededRC =
            returnCodes.getCode('CONTENT_MAX_SIZE_EXCEEDED_RC');
        successRC =
            returnCodes.getCode('SUCCESS_RC');

        // File: protocol only valid on mobile
        if (mobileUtils.isMobile() && mobileUtils.isMobileApp()) {
            supportedProtocols.push('file');
        }

        // Set supported mimetypes
        supportedMimetypes = [];
        for (var mimetype in validMimetypes) {
            if (validMimetypes.hasOwnProperty(mimetype)) {
                supportedMimetypes.push(mimetype);
            }
        }

        // Set supported filename extensions
        supportedExtensions = [];
        for (var i=0; i<supportedMimetypes.length; i++) {
            supportedExtensions = supportedExtensions.concat(
                validMimetypes[supportedMimetypes[i]]);
        }
    }


    // Prototype methods

    // Set the application name, upon which some URLs depend
    Images.prototype.setApplicationName = function (newAppName) {

        // Save app name for possible later use
        appName = newAppName;

        // Update URLs that include the app name
        var lowerAppName = appName.toLowerCase();
        for (var image in siteImages) {
            if (siteImages[image].src.indexOf('APPNAME') >= 0) {
                siteImages[image].src = siteImages[image].src
                    .trim().split('APPNAME').join(lowerAppName);
            }
        }
    };

    // Get image src for specified key, adjusting for path prefix
    Images.prototype.getSrc = function (key, pathPrefix) {
        var src,
            imageKey = key,
            prefix = pathPrefix || '';

        // Construct src if defined
        if (siteImages[imageKey]) {
            src = prefix + siteImages[imageKey].src;
        }

        // Return path to image src
        return src;
    };

    // Get image alt text for specified key
    Images.prototype.getAlt = function (key) {
        return (siteImages[key] ? siteImages[key].alt : undefined);
    };

    // Set src and alt properties on provided img element, adjusting for prefix
    Images.prototype.setAttributes = function (img, key, pathPrefix) {
        if (siteImages[key]) {
            var prefix = pathPrefix || '';
            img.setAttribute('src', prefix + siteImages[key].src);
            if (siteImages[key].alt) {
                img.setAttribute('alt', siteImages[key].alt);
            }
        }
    };

    // Get JPG image orientation as sometimes it might need to be corrected
    // Credit: https://stackoverflow.com/questions/7584794/accessing-jpeg-exif
    //         -rotation-data-in-javascript-on-the-client-side/32490603#32490603
    Images.prototype.getJpegOrientation = function (file, callback) {

        // Instantiate new reader
        var reader = new FileReader();

        // Set onload listener
        var onload = function(e) {
            // Remove listener as we only need it once
            reader.onload = null;

            // Default returnValue
            var returnValue = -1;

            // Create a DataView of the loaded image file
            var view = new DataView(e.target.result);

            // Confirm this is JPEG format
            if (view.getUint16(0, false) != 0xFFD8) {
                returnValue = -2;  // Not JPEG format
            } else {

                // Walk the JPEG data to locate the EXIF section
                var length = view.byteLength,
                    offset = 2;
                while (offset < length) {
                    // Get the marker at the current offset
                    var marker = view.getUint16(offset, false);
                    offset += 2;

                    // Check for EXIF
                    if (marker == 0xFFE1) {
                        // Return if EXIF section does not include orientation
                        if (view.getUint32(offset += 2, false) != 0x45786966) {
                            returnValue = -1;
                            break;
                        }

                        // Retrieve orientation number and return it
                        var little = view.getUint16(offset += 6, false) == 0x4949;
                        offset += view.getUint32(offset + 4, little);
                        var tags = view.getUint16(offset, little);
                        offset += 2;
                        var foundOrientation = false;
                        for (var i = 0; i < tags; i++) {
                            if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                                returnValue =
                                    view.getUint16(offset + (i * 12) + 8, little);
                                foundOrientation = true;
                                break;
                            }
                        }
                        if (foundOrientation) {
                            break;
                        }
                    } else if ((marker & 0xFF00) != 0xFF00) {
                        // Reached the end of EXIF
                        break;
                    } else {
                        // Advance the to the next offset to check for EXIF
                        offset += view.getUint16(offset, false);
                    }
                }
            }
            callback(returnValue);
        };

        // Assign onload listener
        reader.onload = onload;

        // Begin reading in the file
        reader.readAsArrayBuffer(file);
    };

    // Fixup JPEG orientation
    // Credit: https://stackoverflow.com/questions/20600800/
    //         js-client-side-exif-orientation-rotate-and-mirror-jpeg-images
    Images.prototype.resetJpegOrientation = function (dataURI,
                                                      orientation,
                                                      callback) {
        // Capture the input mimetype
        var mimetype = dataURI.substring(5, dataURI.indexOf(';'));

        // Create host image element
        var img = new Image();

        // Set load listener
        img.onload = function() {
            // Get dimensions and setup canvas context
            var width = img.width,
                height = img.height,
                canvas = document.createElement('canvas'),
                context = canvas.getContext("2d");

            // Set proper canvas dimensions
            if ([5,6,7,8].indexOf(orientation) > -1) {
                canvas.width = height;
                canvas.height = width;
            } else {
                canvas.width = width;
                canvas.height = height;
            }

            // Transform context to correct orientation
            switch (orientation) {
                case 2: context.transform(-1, 0, 0, 1, width, 0); break;
                case 3: context.transform(-1, 0, 0, -1, width, height ); break;
                case 4: context.transform(1, 0, 0, -1, 0, height ); break;
                case 5: context.transform(0, 1, 1, 0, 0, 0); break;
                case 6: context.transform(0, 1, -1, 0, height , 0); break;
                case 7: context.transform(0, -1, -1, 0, height , width); break;
                case 8: context.transform(0, -1, 1, 0, 0, width); break;
                default: context.transform(1, 0, 0, 1, 0, 0);
            };

            // Draw image from context
            context.drawImage(img, 0, 0);

            // Return dataURI with corrected image orientation
            callback(canvas.toDataURL(mimetype));
        };

        // Load the host image with image content
        img.src = dataURI;
    };

    // Get the img dataURI (should fail with security error on desktop)
    Images.prototype.getImageDataURI = function (img) {

        // Initialize
        var dataURI = img.src;

        // Get dataURI if data protocol not specified
        if (img.src.indexOf('data:') < 0) {

            // Create a blank canvas
            var canvas = document.createElement('canvas');

            // Set the canvas size based on the img original size
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;

            // Copy the image to the canvas
            var context = canvas.getContext('2d');
            context.drawImage(img, 0, 0);

            // Guess mimetype based on file extension
            var extension = img.src.split('.').pop().toLowerCase(),
                mimetype = 'image/' + extension.replace('jpg','jpeg');

            // Get data URI based on mimetype
            try {
                dataURI = canvas.toDataURL(mimetype);
            } catch (error) {
                // Most likely a SecurityError due to CORS
                dataURI = null;
            }
        }

        // Return dataURI
        return dataURI;
    };

    // Validate submitted img src, which can be a filelist, url, or dataURI
    Images.prototype.validateSrc = function (src, callback) {

        var status = successRC,
            message = 'success',
            protocol,
            extension;

        // Verify src is not empty
        if (!src) {
            status = invalidParameterRC;
            message = 'ERROR: src is undefined!';

        } else if (typeof src === 'string') {

            // Check for dataURI
            if (src.indexOf('data:') === 0) {
                var mimetype = src.substring(5, src.indexOf(';'));
                if (supportedMimetypes.indexOf(mimetype) < 0) {
                    status = invalidParameterRC;
                    message = 'ERROR: dataURI is not valid - ' +
                        src.substring(0, 20) + '...';
                }
            } else {

                // Must be a URL, check format
                if (status === successRC) {
                    if (src.length < 12 || src.indexOf(':') < 0) {
                        status = invalidParameterRC;
                        message = 'ERROR: url is not valid - ' + src;
                    }
                }

                // Verify url protocol
                if (status === successRC) {
                    protocol = src.split(':')[0].toLowerCase();
                    if (supportedProtocols.indexOf(protocol) < 0) {
                        status = invalidParameterRC;
                        message = 'ERROR: protocol is not valid - ' + src;
                    }
                }

                // Get the file extension
                if (status === successRC) {
                    extension = src.split('.').pop().toLowerCase();
                }
            }

        } else if (typeof src === 'object' && typeof src.name === 'string') {

            // Must be a file
            extension = src.name.split('.').pop().toLowerCase();
        }

        // Lastly, check the file extension
        if (status === successRC) {
            if (extension && supportedExtensions.indexOf(extension) < 0) {
                status = invalidParameterRC;
                message = 'ERROR: extension is not valid - ' + extension;
            }
        }

        // Report results
        if (callback) {
            callback(status, message);
        }
    };

    // Get size of the specified image src.  The src can either be a file
    // object from a user selection, or a standard img URL.  The file object
    // provides a size property which can be returned immediately.  However,
    // for img URLs, the Client does not have sufficient security privileges
    // to get the size of the associated file on the remove server.  In this
    // case, the size can only be determined with assistance from the Server,
    // which does have such privileges.
    //
    // This method should only be required on image upload by Merchants
    // or Consumers.  Images uploaded from the app server are already
    // guaranteed to be within size constraints.  So, no need to make
    // and extra request to the server, etc.

    Images.prototype.getSize = function (src, callback) {

        // Validate the src
        this.validateSrc(src, function (status, message) {

            // If src is valid, try to get the size
            if (status == successRC) {

                // Determine url type
                if (typeof src === 'string') {
                    // Not yet implemented on the Server, so send 0
                    if (callback) {
                        callback(0);
                    }
                } else if (typeof src === 'object' &&
                           typeof src.name === 'string') {
                    // Src is a file, get first file from the list
                    // Return file size
                    if (callback) {
                        callback(src.file.size);
                    }
                } else {
                    // Unsupported src
                    if (callback) {
                        callback(-1);
                    }
                }

            } else {

                // Unable to get size or invalid src
                if (callback) {
                    callback(-1);
                }
            }
        });
    };

    // Attempt to load image data from specified src into img element.
    // The src can a fileList object or an http/https URL.  FileList
    // objects include a size parameter to determine if the img is too large.
    // However, the remote http/https URL specified by the user cannot be
    // properly sized by the client.  In this case, a request is sent to
    // the server to return the actual file size.
    //
    // Status return codes are:
    //
    // Status: success
    // Code:   SUCCESS_RC
    //
    // Status: img parameter null, undefined, not a valid img URL
    // Code:   INVALID_PARAMETER_RC
    //
    // Status: timeout
    // Code:   UNEXPECTED_ERROR_RC
    //
    // Status: unable to load image, for any reason
    // Code:   UNABLE_TO_COMPLETE_REQUEST_RC
    //
    Images.prototype.loadImage = function (img, src, callback) {

        // Assume image is valid until proven unworthy
        var status = successRC,
            message = 'success';

        // Validate parameters

        // Verify an img element was provided
        if (status === successRC) {
            if (img == null || typeof img === 'undefined' ||
                !(img.tagName && img.tagName.toLocaleLowerCase() === 'img')) {
                status = invalidParameterRC;
                message = 'ERROR: invalid img element';
            }
        }

        // Verify the src format
        if (status === successRC) {
            if (src == null || typeof src === 'undefined') {
                status = invalidParameterRC;
                message = 'ERROR: image src is not valid - ' + src;
            }
        }

        // Load image based upon src type
        if (status === successRC) {

            // User selected the file from a file browser/camera
            if (typeof src === 'object' && typeof src.name === 'string') {
                // FileList from Desktop Browse and Mobile Camera
                this.loadImageFromFile(img, src, function (status, message) {
                    // Report results
                    if (callback) {
                        callback(status, message);
                    }
                });

            // User typed in the URL to the image
            } else if (typeof src === 'string') {
                // HTTP/HTTPS
                this.loadImageFromURL(img, src, function (status, message) {
                    // Report results
                    if (callback) {
                        callback(status, message);
                    }
                });
            } else {
                // Not a valid image src
                status = invalidParameterRC;
                message = 'ERROR: unrecognized image src - ' + typeof src;
                // Report error
                if (callback) {
                    callback(status, message);
                }
            }
        } else {
            // Report earlier errors
            if (callback) {
                callback(status, message);
            }
        }
    };

    // Load img from file src (Desktop Browse / Mobile Camera)
    Images.prototype.loadImageFromFile = function (img, file, callback) {

         var status = successRC,
             message = 'success';

        // Read file and set img element with contents
        if (file) {

            // Instantiate reader to read in the file
            var reader = new FileReader();

            // Handler when fully read in, add img to parent
            var readerOnload = function (event) {

                // Remove listener as it's only needed once
                reader.onload = null;

                // Capture dataURI
                var dataURI = event.target.result;

                // When the image is fully loaded report status
                var imgOnload = function (event) {
                    // Remove load listener so browser does not reload
                    img.removeEventListener('load', imgOnload, false);
                    // Report status now that the image is loaded
                    if (callback) {
                        callback(status, message);
                    }
                };

                // Set image onload listener
                img.addEventListener('load', imgOnload, false);

                // Set alt text regardless of any img updates
                img.setAttribute('alt', 'Image Loading...');

                // If JPEG format, check orientation for possible fixup
                if (dataURI.indexOf('image/jpg') >= 0 ||
                    dataURI.indexOf('image/jpeg') >= 0) {
                    // Get JPEG file orientation
                    this.getJpegOrientation(file, function (orientation) {
                        // Fixup orientation
                        if (orientation > 0) {
                            this.resetJpegOrientation(dataURI,
                                                      orientation,
                                                      function (dataURI) {
                                // Set img with fixed contents
                                img.setAttribute('src', dataURI);
                            });
                        } else {
                            // Orientation update not required/possible
                            img.setAttribute('src', dataURI);
                        }
                    }.bind(this));
                } else {
                    // Set image content
                    img.setAttribute('src', dataURI);
                }
            }.bind(this);

            // Setup listener for reader onload
            reader.onload = readerOnload;

            // Begin reading in the file selected
            reader.readAsDataURL(file);
        }
    };

    // Load image from specified URL.  Supported protocols
    Images.prototype.loadImageFromURL = function (img, url, callback) {

        // Assume image is valid until proven unworthy
        var status = successRC,
            message = 'success';

        // Validate url
        this.validateSrc (url, function (status, message) {

            // Check if the image can be loaded into an img element
            if (status === successRC) {
                var timeout = false,
                    timer;

                // Set timeout for image load
                timer = setTimeout(function () {
                    timeout = true;
                    // Stop browser from trying to reload
                    img.setAttribute('src', '//This is not a URL/error.jpg');
                    // Report a timeout trying to load the image url
                    status = unexpectedErrorRC;
                    message = 'ERROR: timeout loading url - ' + url;
                    if (callback) {
                        callback(status, message);
                    }
                }, maxLoadTime);

                // Set the error callback if things fail
                var onerror = onabort = function (event) {
                    if (!timeout) {
                        clearTimeout(timer);
                        status = unableToCompleteRequestRC;
                        message = 'ERROR: unable to load image - ' + url;
                        if (callback) {
                            callback(status, message);
                        }
                    }
                };

                // Set the success callback
                var onload = function (event) {

                    // Remove callback on subsequent image loads
                    img.removeEventListener('load', onload, false);

                    // Clear timer, check size, and return status
                    if (!timeout) {
                        // No timeout, so clear the timer before it fires
                        clearTimeout(timer);

                        // Return final status
                        if (callback) {
                            callback(status, message);
                        }
                    }
                }.bind(this);

                // Set load/abort/error callbacks
                img.addEventListener('load', onload, false);
                img.addEventListener('error', onerror, false);
                img.addEventListener('abort', onabort, false);

                // Start loading image
                img.setAttribute('src', url);
                img.setAttribute('alt', 'Verifying Image...');
            } else {
                // Send the encountered error message
                if (callback) {
                    callback(status, message);
                }
            }
        });
    };

    // Get supported image protocols
    Images.prototype.getSupportedProtocals = function () {
        return supportedProtocols;
    };

    // Get supported image mimetypes
    Images.prototype.getSupportedMimetypes = function () {
        return supportedMimetypes;
    };

    // Get supported image extensions
    Images.prototype.getSupportedExtensions = function () {
        return supportedExtensions;
    };

    // Get supported image filename extensions for given mimetype
    Images.prototype.getMimetypeExtensions = function (mimetype) {
        return validMimetypes[mimetype];
    };

    // Get image mimetype for file extension
    Images.prototype.getExtensionMimetype = function (extension) {
        var extensions,
            mimetype;
        for (var i=0; i<supportedMimetypes.length; i++) {
            extensions = validMimetypes[supportedMimetypes[i]];
            if (extensions.indexOf(extension) >= 0) {
                mimetype = supportedMimetypes[i];
                break;
            }
        }
        return mimetype;
    };

    // Get maximum size in megabytes
    Images.prototype.getMaxSize = function () {
        return maxSize;
    }


    // Return the constructor
    return Images.prototype.constructor;
});

